import { deleteSessionStorageItem, dispatchEventUserAuthenticated, getSessionStorageItem, setSessionStorageItem } from "components/utils";
import { isString } from "lodash";

export const getUser = () => {
    const data = getSessionStorageItem("user");

    return isString(data) ? (JSON.parse(data) as User) : {};
};

export const isUserGuest = () => {
    let user: User = {};
    try {
        user = JSON.parse(getSessionStorageItem("user")) || {};
    } catch (e) {}

    return Boolean(user.isGuest);
};

export const saveUser = ({
    firstName,
    lastName,
    userName,
    email,
    serverTimezoneOffset,
    userSessionTimeout,
    accessToken,
    refreshToken,
    customerNumber,
    isGuest,
}: {
    firstName?: string;
    lastName?: string;
    userName?: string;
    email?: string;
    serverTimezoneOffset?: number;
    userSessionTimeout?: number;
    accessToken?: string;
    refreshToken?: string;
    customerNumber?: string;
    isGuest?: boolean;
}) => {
    const sessionExpires = userSessionTimeout ? Date.now() + userSessionTimeout * 60000 : undefined;
    const item = JSON.stringify({
        firstName,
        lastName,
        userName,
        email,
        serverTimezoneOffset,
        userSessionTimeout,
        sessionExpires,
        accessToken,
        refreshToken,
        isGuest,
    });

    if (customerNumber) {
        setSessionStorageItem("customerNumber", customerNumber);
    } else {
        if (accessToken) {
            const customerNumberFromToken = getCustomerNumberFromToken(accessToken);
            if (customerNumberFromToken) {
                setSessionStorageItem("customerNumber", customerNumberFromToken);
            }
        }
    }

    setSessionStorageItem("user", item);
    localStorage.setItem("user", item);

    const isAuthenticated = accessToken && accessToken?.length > 0 && refreshToken && refreshToken?.length > 0;

    dispatchEventUserAuthenticated(isAuthenticated);
};

export const getTokenData = (accessToken: string) => {
    const jwtData = accessToken.split(".")[1];
    const decodedData = window.atob(jwtData);
    return JSON.parse(decodedData) as TokenData;
};

export const getUserNameFromToken = (accessToken: string) => {
    const tokenData = getTokenData(accessToken);
    return tokenData["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"] || "";
};

export const getCustomerNumberFromToken = (accessToken: string) => {
    let customerNumber = "";

    if (accessToken) {
        const tokenData = getTokenData(accessToken);
        customerNumber = tokenData["sub"];
    }

    return customerNumber;
};

const ACCOUNT_PENDING_VERIFICATION_KEY = "accountPendingVerification";

export const getPendingAccountCustomerNumber = () => {
    const data = getSessionStorageItem(ACCOUNT_PENDING_VERIFICATION_KEY);
    return isString(data) && data.length > 0 ? data : null;
};

export const isAccountPendingVerification = () => getPendingAccountCustomerNumber() !== null;

export const setAccountPendingVerification = (customerNumber: string | null | undefined) => {
    if (customerNumber) {
        setSessionStorageItem(ACCOUNT_PENDING_VERIFICATION_KEY, customerNumber);
    } else {
        deleteSessionStorageItem(ACCOUNT_PENDING_VERIFICATION_KEY);
    }
};

export const getCustomerNumber = () => {
    const data = getSessionStorageItem("customerNumber");
    return isString(data) ? data : null;
};

type TokenData = {
    aud: string;
    "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name": string;
    sub: string;
    ClientNumber: string;
    exp: number;
    ExpiresIn: string;
    iss: string;
    SessionId: string;
    UserStatus: string;
};

type User = {
    firstName?: string;
    lastName?: string;
    userName?: string;
    email?: string;
    accessToken?: string;
    refreshToken?: string;
    sessionExpires?: number;
    isGuest?: boolean;
};
